import { render, staticRenderFns } from "./user-picker.vue?vue&type=template&id=0d4f5bc8&"
import script from "./user-picker.vue?vue&type=script&lang=js&"
export * from "./user-picker.vue?vue&type=script&lang=js&"
import style0 from "./user-picker.vue?vue&type=style&index=0&id=0d4f5bc8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports